module.exports = __webpack_public_path__ + "img/Jolie Lee.acbe6ea6.jpg";